import {request} from "./base.service";

class CommentService {
  fetch(commentId) {
    return request().get(`/comments/${commentId}`).then(response => response.data);
  }
}

export default new CommentService();